'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "ListItem": "Polaris-Listbox-Loading__ListItem",
  "Loading": "Polaris-Listbox-Loading"
};

exports.default = styles;
